/**
 * Created by portiz on 2/13/2019.
 */
import React from 'react';
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Form
} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import NavbarDesktop from './navbar-employee/navbar-desktop';
import NavbarMobile from './navbar-employee/navbar-mobile';
import Footer from '../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMoneyCheck} from '@fortawesome/free-solid-svg-icons';
import FormGroupPlan from '../forms/form-group-plan';
import Settings from '../../custom-classes/settings';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window';


// This is the item list
class PlanManager extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            subscriptionsData: null,
            navbarMobile: false,
            didMount: false,
            stripeApiKey: Settings.getStripeToken(),
            planId: props.location.planId ? props.location.planId : null,
            loading: false,
            showModal: false,
            propsModal: null,
            isEdit: props.location.isEdit ? props.location.isEdit : false,
        };
        this.props.addTranslation(global);

        this.handlePlanCreated = this.handlePlanCreated.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.setState({didMount: true});
        this.resize();
    }


    /**
     * Toogles alert modal
     */
    toggleAlertModal(){
        this.setState({showModal: false});
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    handlePlanCreated(data) {
        this.setState({
            planId: data.planId
        });
    }

    /**
     * Renders the main page
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}

                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faMoneyCheck}/>{' '}
                            <Translate id="plan.plan-manager"/>
                        </h2>
                        <small className="white-text">
                            <Translate id="plan.plan-manager-instructions"/>
                        </small>
                        <hr/>
                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-white">
                                    <CardBody>
                                        <Form>
                                            <FormGroupPlan data={this.state} updateParent={this.handlePlanCreated}/>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <hr/>
                    </Container>
                </div>
                <Footer/>
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showModal ?
                    <ModalGeneric isEdit={true} data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}
            </div>
        )
    };
}

export default withLocalize(PlanManager);